export const ReviewsData = [
  {
    name: 'John Doe',
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600',
    date: '09-10-2022',
    comment:
      'I had a great time eating delicious meal at your restaurant.The waiters and waitresses were committed to great service and were very friendly to say. The atmosphere was friendly and I liked that you have a very modern style.Most importantly, the drinks and food on your menu were very delicious and tasted great. ',
  },
  {
    name: 'Liam Smith',
    image:
      'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=600',
    date: '02-6-2022',
    comment:
      'This cozy restaurant has left the best impressions! Hospitable hosts, delicious dishes, beautiful presentation, wide wine list and wonderful dessert. I recommend to everyone! I would like to come back here again and again.',
  },
  {
    name: 'Antony Bonito',
    image:
      'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=600',
    date: '7-10-2022',
    comment:
      ' It’s a great experience. The ambiance is very welcoming and charming. Amazing wines, food and service. Staff are extremely knowledgeable and make great recommendations.',
  },
  {
    name: 'Jojo Young',
    image:
      'https://images.pexels.com/photos/712513/pexels-photo-712513.jpeg?auto=compress&cs=tinysrgb&w=600',
    date: '10-10-2022',
    comment:
      ' This place is great! Atmosphere is chill and cool but the staff is also really friendly. They know what they’re doing and what they’re talking about, and you can tell making the customers happy is their main priority. Food is pretty good, some italian classics and some twists, and for their prices it’s 100% worth it',
  },
  {
    name: 'Wright Jules',
    image:
      'https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=600',
    date: '23-09-2022',
    comment:
      'The staff is really what has me coming back.This location has a great set of people,they are wonderful, friendly,so sweet and hard working!!! It is also very busy at this location and the employees are just darn nice  and great! Thankyou!!!I know how hard it can get sometimes, but lemme tell yah, This staff is the best!!!Amazing.',
  },
]
